import { dmApi } from "../../../app/dmApi";
import {
  getAuthorizationHeader,
  handleQueryError,
  handleQueryErrorAndSuccess,
} from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const systemVariablesApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getEnvVariables: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/env-variables?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["envVariables"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    updateEnvVariable: build.mutation({
      query: ({ id, requestBody }) => ({
        url: `/update-env-value/${id}`,
        method: "PUT",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["envVariables"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Variable");
      },
    }),

  }),
});

export const {
  useGetEnvVariablesQuery,
  useGetAllEnvVariablesQuery,
  useUpdateEnvVariableMutation,
} = systemVariablesApi;
